import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    observationIntralaboral(_, queryParams) {
        return axios.post(`${serverUrl}/reports/personal_observation/personal_observation_intralaboral/`, queryParams)
    },
    observationExtralaboral(_, queryParams) {
        return axios.post(`${serverUrl}/reports/personal_observation/personal_observation_extralaboral/`, queryParams)
    },
    observationStress(_, queryParams) {
        return axios.post(`${serverUrl}/reports/personal_observation/personal_observation_stress/`, queryParams)
    },
    observationDemographic(_, queryParams) {
        return axios.post(`${serverUrl}/reports/demographic_observation/demographic_observation/`, queryParams)
    },
    observationGeneralAandB(_, queryParams) {
        return axios.post(`${serverUrl}/reports/general_AandB_observation/a_and_b_observation/`, queryParams)
    }
}